import React from "react";
import Settings from "components/Panel/Customer/Settings";
const SettingsContainer = () => {
  return <Settings />;
};

export default SettingsContainer;
